import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { FaCheckCircle, FaApple, FaGooglePlay } from 'react-icons/fa';

const Success = () => {
  const navigate = useNavigate();

  return (
    <div className="auth-page-wrapper" style={{
      minHeight: "100vh",
      display: "flex",
      alignItems: "center",
      background: "linear-gradient(135deg, #f8faff 0%, #e0e7ff 100%)",
      padding: "80px 0"
    }}>
      <Container>
        <Row className="justify-content-center text-center">
          <Col md={8} lg={6} xl={5}>
            <div className="shadow-2xl p-5" style={{
              background: "rgba(255, 255, 255, 0.9)",
              backdropFilter: "blur(20px)",
              borderRadius: "30px",
              border: "1px solid rgba(255, 255, 255, 0.5)"
            }}>
              
              <div className="mb-4" style={{
                width: "90px",
                height: "90px",
                background: "#dcfce7",
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                margin: "0 auto",
                boxShadow: "0 10px 20px rgba(34, 197, 94, 0.15)"
              }}>
                <FaCheckCircle size={45} color="#22c55e" />
              </div>

              <h2 className="fw-black mb-3" style={{ color: "#1e293b", fontWeight: 900 }}>Tebrikler!</h2>
              <h4 className="fw-bold mb-4" style={{ color: "#334155" }}>Paket Satın Alımınız Onaylandı</h4>

              <div className="mb-4" style={{
                background: "linear-gradient(135deg, #e0e7ff 0%, #c7d2fe 100%)",
                borderRadius: "20px",
                padding: "25px 20px",
                border: "1px solid rgba(79, 70, 229, 0.15)"
              }}>
                <h5 className="fw-bold mb-3" style={{ color: "#312e81" }}>Hemen Kullanmaya Başlayın!</h5>
                <p className="mb-4 small text-indigo-900 fw-medium" style={{ color: "#3730a3", fontSize: '0.95rem' }}>
                  Aboneliğiniz başarıyla aktif edilmiştir. 
                  Uygulamamızı cihazınıza indirip <strong>bu sitede oluşturduğunuz kullanıcı adı ve şifrenizle</strong> anında giriş yapabilirsiniz.
                </p>

                {/* İndirme Butonları */}
                <div className="d-flex flex-column gap-3 mt-2">
                  <a href="https://apps.apple.com/us/app/miras%C4%B1m/id6759550556" target="_blank" rel="noopener noreferrer" 
                     className="btn btn-dark rounded-pill py-2 d-flex align-items-center justify-content-center fw-bold shadow-sm">
                    <FaApple size={22} className="me-2" /> App Store'dan İndir
                  </a>
                  <a href="https://play.google.com/store/apps/details?id=com.stai.mirasim" target="_blank" rel="noopener noreferrer" 
                     className="btn btn-secondary rounded-pill py-2 d-flex align-items-center justify-content-center fw-bold shadow-sm" style={{background: "#334155", border: "none"}}>
                    <FaGooglePlay size={20} className="me-2" /> Google Play'den İndir
                  </a>
                </div>
              </div>

              <div className="d-grid mt-4">
                <Button
                  onClick={() => navigate("/")}
                  variant="outline-primary"
                  className="py-3 rounded-pill fw-bold"
                >
                  Ana Sayfaya Dön
                </Button>
              </div>

            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Success;
